import { Extension } from '@tiptap/react'

import { MentionSuggestionModel } from './MentionSuggestionModel'

export type MentionStorageType = Record<
  string,
  {
    suggestions: MentionSuggestionModel[]
    selected?: { id: string; name: string; avatarName: string }
  }
>

export const MentionStorage = Extension.create<
  Record<string, never>,
  MentionStorageType
>({
  name: 'MentionStorage',
  addStorage() {
    return {} satisfies MentionStorageType
  }
})
